import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { IState } from 'services/root-reducer';
import {
    Button,
    Popover,
    Radio,
    Checkbox,
    Icons
} from 'components';
import { OverlayMessage } from 'scenes/overlay-message';
import { ROOT_RENDER_ID } from 'project-constants';
import { IBaseMapConf } from 'types';
import { ImageSaver } from './image-saver';
import './style.scss';

export interface IMapToImageControl {
    className?: string;
    view: IState['omjs']['omjsViewInstance'],
    currentBaseMapId: number,
    layersList: IBaseMapConf[];
}

export const MapToImageControl: React.FC<IMapToImageControl> = (props): JSX.Element => {
    const {
        className = '',
        view,
        currentBaseMapId,
        layersList
    } = props;

    const [ referenceElement, setReferenceElement ] = useState(null);
    const [ showPopover, setShowPopover ] = useState(false);
    const [ selectedScale, setSelectedScale ] = useState(1);
    const [ drawTitle, setDrawTitle ] = useState(false);
    const [ imageSaver, setImageSaver ] = useState(null);
    const [ showMessage, setShowMessage ] = useState(false);
    const { t } = useTranslation();

    const rootEl = useMemo(() => document.getElementById(ROOT_RENDER_ID), []);

    useEffect(() => {
        setImageSaver(new ImageSaver(view));
        return () => {
            setImageSaver(null);
        };
    }, []);

    const renderResolutions = () => {
        const scales = [ 1, 2, 3, 4 ];
        const mapWidth = view.getContainer()['width']();
        const mapHeight = view.getContainer()['height']();

        return scales.map(scale => (
            <li className="oms-map-to-img-control__wrapper" key={scale}>
                <label className="oms-map-to-img-control__item">
                    <Radio checked={scale === selectedScale} onChange={() => setSelectedScale(scale)} />
                    <span className="oms-map-to-img-control__item-name">
                        { scale === 1 ? t('Оригинал') : `HiDPI ${scale * mapWidth}x${scale * mapHeight}` }
                    </span>
                </label>
            </li>
        ));
    };

    const handleSaveImage = (format: string) => {
        const currentBaseLayer = layersList.find(l => l.id === currentBaseMapId);
        if (currentBaseLayer.value.includes('yandex') || currentBaseLayer.value.includes('google')) {
            setShowMessage(true);
        } else {
            imageSaver.saveImage({
                scale: selectedScale,
                showTitle: drawTitle,
                format
            });
        }
    };

    return (
        <React.Fragment>
            <Button
                ref={setReferenceElement}
                onClick={() => setShowPopover(true)}
                onMouseEnter={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                icon={<Icons.IconDownload />}
                variant='black'
            />
            <Popover
                hideTimeout={300}
                showTimeout={300}
                targetElement={referenceElement}
                offset={[ 0, 4 ]}
                placement="left-start"
                open={showPopover}
            >
                <ul className="oms-map-to-img-control">
                    { renderResolutions() }
                    {/*
                    <li className="oms-map-to-img-control__wrapper">
                        <label className="oms-map-to-img-control__item">
                            <Checkbox checked={drawTitle} onChange={() => setDrawTitle(!drawTitle)} />
                            <span className="oms-map-to-img-control__item-name">
                                {t('Заголовок')}
                            </span>
                        </label>
                    </li>
                    */}
                </ul>
                <div className="oms-map-to-img-control__buttons">
                    <Button
                        text='PNG'
                        onClick={() => handleSaveImage('png')}
                    />
                    <Button
                        text='JPEG'
                        onClick={() => handleSaveImage('jpeg')}
                    />
                </div>
            </Popover>
            {rootEl && showMessage && ReactDOM.createPortal(
                <OverlayMessage
                    messageText={t('Эта функция недоступна при использовании карт Яндекс '
                        + 'или Спутниковых снимков в качестве подложки')}
                    onCloseButtonClick={() => setShowMessage(false)}
                />, rootEl
            )}
        </React.Fragment>
    );
};
